import axios from 'axios';
import { publishMessage } from 'components/ShireMessage';
import { BASE_URL } from 'utils/constant';

const axiosClient = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
});

let setLoadingCallback: ((loading: boolean) => void) | null = null;
let requestCount = 0;
export const setLoadingHandler = (handler: (loading: boolean) => void) => {
  setLoadingCallback = handler;
};

axiosClient.interceptors.request.use(
  (config) => {
    requestCount++;
    setLoadingCallback?.(true);
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${token}`;
      config.headers['ngrok-skip-browser-warning'] = 'true';
    }
    return config;
  },
  (error) => {
    requestCount = Math.max(requestCount - 1, 0);
    if (requestCount === 0) setLoadingCallback?.(false);
    // return Promise.reject(error);
    publishMessage({
      message: error.response?.data?.message || 'Có lỗi xảy ra, vui lòng thử lại sau',
      variant: 'error',
    });
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  (response) => {
    requestCount = Math.max(requestCount - 1, 0);
    if (requestCount === 0) setLoadingCallback?.(false);
    return response;
  },
  (error) => {
    requestCount = Math.max(requestCount - 1, 0);
    if (requestCount === 0) setLoadingCallback?.(false);
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      window.location.href = '/signin';
    }
    if (error.response && error.response.status === 403) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      window.location.href = '/signin';
    }

    if (error.response && error.response.status >= 400 && error.response.status < 500) {
      publishMessage({
        message: error.response?.data?.message || 'Có lỗi xảy ra, vui lòng thử lại sau',
        variant: 'error',
      });
    }

    if (error.response && error.response.status === 500) {
      publishMessage({
        message: error.response?.data?.message || 'Có lỗi xảy ra, vui lòng thử lại sau',
        variant: 'error',
      });
    }

    return Promise.reject(error);
  }
);

export default axiosClient;